import React from 'react';
import qs from 'query-string';
import { useDispatch, useSelector } from 'react-redux';
import { setVisitOnBoarding } from 'redux/slice/stores';
import CONST_ENV from 'services/env';
import { booleanParser } from 'services/booleanParser';
import { isWhiteLabelProject } from 'utils/isWhiteLabelProject';

const PROJECT_NAMES = {
	ENTEKHAB: 'entekhab',
	KEEPA: 'keepa',
	TANTAK: 'tantak',
	FARA: 'fara',
	SABALEND: 'sabalend',
	REFAHYAR: 'refahyar',
	HAMTALAND: 'hamtaland',
	RAYANSAIPA: 'rayansaipa',
	GHESTANE: 'ghestane',
	DEMO: 'demo',
	TISA: 'tisa',
	SAANA: 'saana',
	SHOPP: 'shopp',
	ARBAEEN: 'arbaeen',
	HASTESH: 'hastesh',
	ARMANPAY: 'armanpay',
	LENDAVID: 'lendavid',
	FLYTODAY: 'flytoday',
	CALKO: 'calko',
	CAN: 'can',
	DANESH: 'danesh',
	KARMA: 'karma',
};

const useWhiteLabelProject = () => {
	const dispatch = useDispatch();
	const isWhiteLabelDomain = isWhiteLabelProject();
	const project = process.env.REACT_APP_PROJECT_NAME;
	const isDev = booleanParser(process.env.REACT_APP_TEST_SERVER);
	const token = useSelector((state) => state.login.token);

	const checkProject = (projectName) => project === projectName;

	const projectStatus = {
		isWhiteLabelDomain,
		isEntekhab: checkProject(PROJECT_NAMES.ENTEKHAB),
		isKeepa: checkProject(PROJECT_NAMES.KEEPA),
		isDarsad: checkProject(PROJECT_NAMES.TANTAK),
		isFara: checkProject(PROJECT_NAMES.FARA),
		isNRDarsad:
			checkProject(PROJECT_NAMES.TANTAK) &&
			[isDev ? 111111191 : 111111215].includes(CONST_ENV.REACT_APP_TANTAK_IDS?.[2]),
		isSabahlend: checkProject(PROJECT_NAMES.SABALEND),
		isRefahYar: checkProject(PROJECT_NAMES.REFAHYAR),
		isHamtaland: checkProject(PROJECT_NAMES.HAMTALAND),
		isRayansaipa: checkProject(PROJECT_NAMES.RAYANSAIPA),
		isGhestane: checkProject(PROJECT_NAMES.GHESTANE),
		isCan: checkProject(PROJECT_NAMES.CAN),
		isDemo: checkProject(PROJECT_NAMES.DEMO),
		isTisa: checkProject(PROJECT_NAMES.TISA),
		isSaana: checkProject(PROJECT_NAMES.SAANA),
		isShopp: checkProject(PROJECT_NAMES.SHOPP),
		isArbaeen: checkProject(PROJECT_NAMES.ARBAEEN),
		isHastesh: checkProject(PROJECT_NAMES.HASTESH),
		isArmanPay: checkProject(PROJECT_NAMES.ARMANPAY),
		isLendavid: checkProject(PROJECT_NAMES.LENDAVID),
		isFlyToday: checkProject(PROJECT_NAMES.FLYTODAY),
		isCalko: checkProject(PROJECT_NAMES.CALKO),
		isDanesh: checkProject(PROJECT_NAMES.DANESH),
		isKarma: checkProject(PROJECT_NAMES.KARMA),
	};

	React.useEffect(() => {
		const parsedToken = qs.parse(`?token=${token}`);
		if (isWhiteLabelDomain && (!parsedToken?.token || parsedToken?.token === 'null')) {
			dispatch(setVisitOnBoarding(false));
		}
	}, [dispatch, isWhiteLabelDomain, token]);

	return projectStatus;
};

export default useWhiteLabelProject;
